export const COPING_STRATEGY_TYPES = {
    COPING_STATEMENT: "coping_statement",
};
